import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { ElectronicDocumentDisablement } from "../../models/electronic-document-disablement";

interface DisablementDeleteModalProps {
  show: boolean;
  disablement?: ElectronicDocumentDisablement;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DisablementDeleteModal: React.FC<DisablementDeleteModalProps> = ({
  show,
  disablement,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = disablement
    ? `Está seguro de que quiere eliminar la inutilización #${disablement.id}`
    : "";

  const onDeleteClick = async () => {
    if (disablement !== undefined) {
      setSubmitting(true);
      const disablementStatus = await deleteItem(
        `/disablements/${disablement.id}/`,
        disablement
      );

      if (disablementStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (disablementStatus.detail !== undefined) {
          message = disablementStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DisablementDeleteModal;
